// Mock data for E2-Return Landing Page

export const industries = [
  {
    id: 1,
    title: "Food & Beverage Manufacturing",
    description: "Track reusable crates and containers across production facilities",
    image: "https://images.unsplash.com/photo-1565891741441-64926e441838"
  },
  {
    id: 2,
    title: "Automotive & Industrial Manufacturing",
    description: "Monitor parts containers and returnable packaging in real-time",
    image: "https://images.unsplash.com/photo-1567789884554-0b844b597180"
  },
  {
    id: 3,
    title: "Pharmaceuticals & Healthcare",
    description: "Ensure compliance with tracked reusable medical containers",
    image: "https://images.unsplash.com/photo-1757578097654-fdae0f7cf008"
  },
  {
    id: 4,
    title: "Airports & Ground Handling",
    description: "Track airport equipment, cargo containers, and ground handling assets",
    image: "https://images.unsplash.com/photo-1760055588321-7c5b3ff46394"
  },
  {
    id: 5,
    title: "Retail & FMCG",
    description: "Optimize returnable packaging flow across distribution networks",
    image: "https://images.unsplash.com/photo-1644079446600-219068676743"
  },
  {
    id: 6,
    title: "Postal & Parcel Networks",
    description: "Track roll cages and reusable containers across sorting centers",
    image: "https://images.unsplash.com/photo-1692959269682-7795401d4100"
  },
  {
    id: 7,
    title: "Cold Chain",
    description: "Monitor temperature-controlled returnable packaging assets",
    image: "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e"
  },
  {
    id: 8,
    title: "Circular Economy / Reusable Packaging Providers",
    description: "Enable sustainable packaging pool management and rotation",
    image: "https://images.unsplash.com/photo-1587316745726-41d3e8b4942d"
  }
];

export const useCases = [
  {
    id: 1,
    title: "Campus-to-Campus Flows",
    description: "Track assets moving between your facilities with E2 network",
    image: "https://images.unsplash.com/photo-1644079446600-219068676743"
  },
  {
    id: 2,
    title: "Tracking Between Factories",
    description: "Real-time visibility of returnable packaging across production sites",
    image: "https://images.unsplash.com/photo-1647427060118-4911c9821b82"
  },
  {
    id: 3,
    title: "Third-Party Logistics Visibility",
    description: "Monitor assets with external partners using GPS or portable relays",
    image: "https://images.pexels.com/photos/1267329/pexels-photo-1267329.jpeg"
  },
  {
    id: 4,
    title: "Internal Airport Tracking",
    description: "Track ground handling equipment and cargo containers on-site",
    image: "https://images.pexels.com/photos/33175097/pexels-photo-33175097.jpeg"
  },
  {
    id: 5,
    title: "Returnable Packaging Pools",
    description: "Manage shared container pools across multiple partners",
    image: "https://images.unsplash.com/photo-1734510722516-5a558dc910d2"
  },
  {
    id: 6,
    title: "RPAI Rotations",
    description: "Optimize rotation of reusable packaging and instruments",
    image: "https://images.unsplash.com/photo-1759300635757-19ab99f4cfed"
  },
  {
    id: 7,
    title: "Roll Cage Tracking",
    description: "Never lose roll cages in distribution and retail networks",
    image: "https://images.unsplash.com/photo-1594571194668-7112042d8f54"
  }
];

export const products = [
  {
    id: 1,
    name: "E2 Tags",
    description: "Battery-powered BLE tags for asset tracking",
    features: [
      "Long battery life (up to 5 years)",
      "Compact, rugged design",
      "Easy attachment to any asset"
    ],
    image: "https://images.unsplash.com/photo-1650809652009-6e2789d3bab6"
  },
  {
    id: 2,
    name: "E2 Repeaters & Relays",
    description: "Build network coverage across facilities",
    features: [
      "No SIM card or subscription needed",
      "Plug-and-play installation",
      "Real-time on-campus tracking"
    ],
    image: "https://images.unsplash.com/photo-1732247429548-ede5fbfee3f0"
  },
  {
    id: 3,
    name: "GPS + GSM Tracker",
    description: "Optional off-campus tracking solution",
    features: [
      "Long-range GPS tracking",
      "GSM connectivity",
      "Ideal for high-value shipments"
    ],
    image: "https://images.unsplash.com/photo-1625217527288-93919c99650a"
  }
];

export const benefits = [
  {
    icon: "TrendingDown",
    title: "Reduce Losses",
    description: "Eliminate missing crates, pallets, and containers with real-time tracking"
  },
  {
    icon: "Zap",
    title: "Improve Rotation Speed",
    description: "Optimize asset utilization and reduce idle time"
  },
  {
    icon: "Activity",
    title: "Automate Tracking",
    description: "Replace manual counts with automated departure/arrival logging"
  },
  {
    icon: "MapPin",
    title: "Reliable Inter-Site Visibility",
    description: "Track assets across multiple facilities without GPS costs"
  },
  {
    icon: "Users",
    title: "Works with External Partners",
    description: "Maintain visibility even with third-party logistics providers"
  },
  {
    icon: "DollarSign",
    title: "Cost-Effective Solution",
    description: "No SIM cards, subscriptions, or expensive GPS infrastructure"
  }
];

export const faqData = [
  {
    question: "How does E2-Return work without GPS or SIM cards?",
    answer: "E2-Return uses a BLE network with on-site repeaters and relays. Tags communicate with nearby repeaters, which relay data to your local network. For off-campus tracking, you can optionally add GPS/GSM trackers or portable battery-powered relays."
  },
  {
    question: "What is the range of the E2 network?",
    answer: "Each repeater covers approximately 50-100 meters indoors. By installing multiple repeaters, you can cover entire warehouses, production facilities, and campus sites with seamless connectivity."
  },
  {
    question: "Can I track assets moving between different sites?",
    answer: "Yes! Assets moving between your own sites are tracked via inter-site E2 network visibility. For external logistics partners, you can use portable battery-powered relays or optional GPS trackers."
  },
  {
    question: "How long do the batteries last?",
    answer: "E2 Tags have battery life of up to 5 years depending on transmission frequency. Repeaters are powered via standard electrical outlets. GPS trackers typically last 3-6 months on a charge."
  },
  {
    question: "What types of assets can be tracked?",
    answer: "Any returnable packaging: plastic crates, wooden pallets, metal containers, roll cages, RPAI, airport equipment (ULDs, dollies, baggage carts), and any reusable assets you need to monitor."
  },
  {
    question: "How quickly can E2-Return be deployed?",
    answer: "Most on-campus deployments are completed within 24 hours. Simply install repeaters on walls, attach tags to assets, and configure the dashboard. No complex IT infrastructure needed."
  },
  {
    question: "Does E2-Return integrate with our existing systems?",
    answer: "Yes, E2-Return provides REST API access for integration with your ERP, WMS, TMS, or custom systems. We also offer webhooks for real-time event notifications."
  },
  {
    question: "What's the difference between on-campus and off-campus tracking?",
    answer: "On-campus uses the E2 network (no SIM/GPS needed). Off-campus tracking requires either: (1) a portable battery-powered relay shipped with assets, or (2) GPS+GSM trackers for high-value shipments."
  }
];

export const formSubmissionHandler = (formData) => {
  console.log("Form submitted with data:", formData);
  // Mock form submission - will be replaced with actual API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};
